import { Box, Typography } from "@mui/material";

type Props = {
  title: string;
};

const PageTitle = ({ title }: Props) => (
  <Box py="20px" px="10px">
    <Typography fontSize="32px" fontWeight="600" variant="header">
      {title}
    </Typography>
  </Box>
);

export default PageTitle;
